'use client';

import Link from 'next/link';
import { useWindowScroll } from '@uidotdev/usehooks';
import { IconLogo } from 'app/components/sprites';
import classNames from 'classnames';

export default function HeaderMainLink() {
  const [{ y }] = useWindowScroll();

  return (
    <Link href="/" className="relative block">
      <span
        className={classNames(
          'rounded-full w-[114%] h-[114%] abs-center transition-colors duration-200',
          { 'bg-sand-dark': y && y > 300 }
        )}
      ></span>
      <span className="block relative">
        <IconLogo />
      </span>
    </Link>
  );
}
